import { useState, useEffect } from 'react';
import axios from 'axios';
import { Bot, Plus, Save, X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/atendimento`;
const headers = () => ({Authorization: `Bearer ${localStorage.getItem('recupnet_token')}`});

export default function AtendimentoAgents() {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);

  const fetch_ = () => { axios.get(`${API}/agents`, {headers: headers()}).then(r => setAgents(r.data)).finally(() => setLoading(false)); };
  useEffect(() => { fetch_(); }, []);

  const save = async () => {
    if (!editing) return;
    if (editing.id) {
      await axios.put(`${API}/agents/${editing.id}`, editing, {headers: headers()});
    } else {
      await axios.post(`${API}/agents`, editing, {headers: headers()});
    }
    setEditing(null); fetch_();
  };

  return (
    <div className="p-6 space-y-5">
      <div className="flex items-center justify-between">
        <div><h1 className="font-display text-2xl font-semibold">Agentes IA</h1><p className="text-sm text-white/40">Configure agentes de atendimento automatico</p></div>
        <button onClick={() => setEditing({name:'',role:'',tone:'Profissional',mode:'reception',systemPrompt:'',forbiddenTopics:[],transbordRules:[]})} className="btn-primary flex items-center gap-2 text-sm"><Plus size={16}/> Novo Agente</button>
      </div>

      {/* Agent list */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {agents.map(a => (
          <div key={a.id} className="glass-card cursor-pointer" onClick={() => setEditing(a)}>
            <div className="flex items-center gap-2 mb-2"><Bot size={18} style={{color:'var(--rn-green)'}}/><h3 className="text-sm font-semibold">{a.name}</h3></div>
            <p className="text-[10px] text-white/40 mb-1">Papel: {a.role || '—'}</p>
            <p className="text-[10px] text-white/40 mb-1">Modo: {a.mode}</p>
            <p className="text-[10px] text-white/40">Tom: {a.tone}</p>
            <span className={`mt-2 inline-block ${a.active ? 'badge-success' : 'badge-neutral'} text-[9px]`}>{a.active ? 'Ativo' : 'Inativo'}</span>
          </div>
        ))}
      </div>

      {/* Edit modal */}
      {editing && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4" onClick={() => setEditing(null)}>
          <div className="bg-[#111817] border border-white/10 rounded-2xl w-full max-w-lg max-h-[85vh] overflow-y-auto p-6" onClick={e=>e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-display text-lg font-semibold">{editing.id ? 'Editar Agente' : 'Novo Agente'}</h3>
              <button onClick={() => setEditing(null)}><X size={18}/></button>
            </div>
            <div className="space-y-3">
              <input value={editing.name} onChange={e=>setEditing({...editing,name:e.target.value})} placeholder="Nome do agente" className="w-full bg-black/20 border border-white/10 text-white text-sm rounded-xl px-4 py-2.5 focus:outline-none focus:ring-1 focus:ring-[rgba(99,203,182,0.3)]"/>
              <input value={editing.role} onChange={e=>setEditing({...editing,role:e.target.value})} placeholder="Papel (ex: recepcao, suporte)" className="w-full bg-black/20 border border-white/10 text-white text-sm rounded-xl px-4 py-2.5 focus:outline-none focus:ring-1 focus:ring-[rgba(99,203,182,0.3)]"/>
              <select value={editing.mode} onChange={e=>setEditing({...editing,mode:e.target.value})} className="w-full bg-black/20 border border-white/10 text-white text-sm rounded-xl px-4 py-2.5">
                <option value="reception">Recepcao</option><option value="triage">Triagem</option><option value="faq">FAQ</option><option value="support">Suporte</option><option value="collection">Cobranca</option><option value="follow_up">Acompanhamento</option><option value="hybrid">Hibrido</option>
              </select>
              <input value={editing.tone} onChange={e=>setEditing({...editing,tone:e.target.value})} placeholder="Tom de voz" className="w-full bg-black/20 border border-white/10 text-white text-sm rounded-xl px-4 py-2.5 focus:outline-none focus:ring-1 focus:ring-[rgba(99,203,182,0.3)]"/>
              <textarea value={editing.systemPrompt} onChange={e=>setEditing({...editing,systemPrompt:e.target.value})} placeholder="Prompt do sistema (instrucoes para a IA)" rows={4} className="w-full bg-black/20 border border-white/10 text-white text-sm rounded-xl px-4 py-2.5 focus:outline-none focus:ring-1 focus:ring-[rgba(99,203,182,0.3)]"/>
              <button onClick={save} className="w-full btn-primary py-2.5 text-sm flex items-center justify-center gap-2"><Save size={14}/> Salvar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
